import React from "react";

const SkeletonLoading = ({ itemCount = 4, variant = "list" }) => {
    if (variant === "detail") {
        return (
            <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:mt-4">
                <div className="tw:flex-1 tw:p-8 tw:animate-pulse">
                    {/* Back link */}
                    <div className="tw:h-4 tw:w-32 tw:bg-gray-100 tw:rounded tw:mb-6" />
                    {/* Title + date */}
                    <div className="tw:h-5 tw:w-72 tw:bg-gray-200 tw:rounded tw:mb-3" />
                    <div className="tw:h-3 tw:w-40 tw:bg-gray-100 tw:rounded tw:mb-8" />
                    {/* Body lines */}
                    <div className="tw:space-y-3">
                        <div className="tw:h-3 tw:w-full tw:bg-gray-100 tw:rounded" />
                        <div className="tw:h-3 tw:w-full tw:bg-gray-100 tw:rounded" />
                        <div className="tw:h-3 tw:w-3/4 tw:bg-gray-100 tw:rounded" />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] card-myPage tw:my-2">
            <div className="tw:flex-1 tw:p-6 tw:animate-pulse">
                {/* Section title */}
                <div className="tw:h-5 tw:w-40 tw:bg-gray-200 tw:rounded tw:mb-6" />

                {[...Array(itemCount)].map((_, index) => (
                    <div key={index} className="tw:bg-white tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:shadow-[0_0.125rem_0.25rem_rgba(0,0,0,0.075)] tw:mb-4 tw:p-4">
                        <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-4">
                            <div className="tw:flex-1 tw:min-w-48 tw:my-2">
                                <div className="tw:h-4 tw:w-48 tw:bg-gray-200 tw:rounded tw:mb-3" />
                                <div className="tw:h-3 tw:w-full tw:max-w-xl tw:bg-gray-100 tw:rounded" />
                            </div>
                            <div className="tw:h-8 tw:w-32 tw:bg-gray-200 tw:rounded-[0.375rem]" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SkeletonLoading;
